module.exports = __webpack_public_path__ + "static/media/entertainment.e23df0c1.svg";